import { Deserializable } from '../../protocols/deserializable';
import { BaseUser } from '../../base/base-user';
import { SubmissionPermission } from '../../permissions/dto/submission-permission';
import { ProfileBadgeConfiguration } from './profile-badge-configuration';
import { DateUtils } from '../../../utils/date-utils';

export class InternalUser extends BaseUser implements Deserializable {
  mfaSecretCode!: string | null;
  profileBadgeConfiguration!: ProfileBadgeConfiguration;
  setInactiveById: number | null = null;
  setInactiveByName: string | null = null;
  setInactiveDate: string | null = null;
  submissionPermissions: SubmissionPermission[] = [];

  // Not from API
  public initials: string = '';
  public setToInactiveString: string = '';

  onDeserialize() {
    super.onDeserialize();
    this.initials = `${this.firstName?.charAt(0)}${this.lastName?.charAt(0)}`;
    if (!this.active && !!this.setInactiveDate) {
      this.setToInactiveString = `Set to inactive by ${
        this.setInactiveByName
      } on ${DateUtils.formatISOStringToCurrentDateTime(this.setInactiveDate)}`;
    }

    if (this.profileBadgeConfiguration) {
      this.profileBadgeConfiguration = window?.injector?.Deserialize?.instanceOf(
        ProfileBadgeConfiguration,
        this.profileBadgeConfiguration
      );
    }
  }
}
